import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { images } from '../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../Utils/helper';
// import { Image } from "../../Product/ProductDetail/styled";
import { fireCategoryClickHandler } from '../instrumentation';
import { LthreeList } from './styled';

export default function CategoryFilterRecursionLevel2(props) {
  const { element, i } = props;
  const router = useRouter();
  return (
    <Link
      href={{
        pathname: element?.parentKey,
        query: removeDefaultParams(router.query),
      }}
      passHref
      key={`catdropdownL3Level${i}`}
      locale={false}
    >
      <LthreeList
        onclick={() => fireCategoryClickHandler(element, 'l3', 'child')}
      >
        <li
          style={{
            textTransform: 'capitalize',
          }}
          className={element?.isSelected ? 'selected' : ''}
        >
          {element?.tabName?.toLowerCase()}
          <Image
            src={images.arrowforward}
            alt="arrowForwared"
            height="16px"
            width="16px"
          />
        </li>
      </LthreeList>
    </Link>
  );
}
